import { useMemo } from "react";
import { linkedCalendarsRef } from "../lib/data/availability";
import { useFirestoreCollection } from "./useFirestoreCollection";

export function useLinkedCalendars(uid) {
  const queryRef = useMemo(() => (uid ? linkedCalendarsRef(uid) : null), [uid]);
  return useFirestoreCollection(queryRef);
}
